module.exports = __webpack_public_path__ + "img/manda_022.44390f8f.png";